<template>
  <div>
    <!-- Upgrade to Pro -->
    <v-list-item
      v-if="!user.is_pro && !user.is_pro_team && currentUser.loggedIn"
      @click="$emit('upgrade', 'pro')"
      :disabled="loading"
    >
      <v-list-item-icon>
        <v-icon v-if="!loading" color="primary">mdi-star-three-points-outline</v-icon>
        <v-progress-circular
          v-else
          indeterminate
          size="24"
          width="2"
        ></v-progress-circular>
      </v-list-item-icon>
      <v-list-item-title class="d-flex align-center try-pro-text">
        {{ loading ? 'Processing...' : 'Try Pro' }}
      </v-list-item-title>
    </v-list-item>

    <!-- Upgrade to Team Pro -->
    <v-list-item
      v-if="user.is_pro && !user.is_pro_team && currentUser.loggedIn && isActiveSubscription"
      @click="$emit('upgrade', 'team_pro')"
      :disabled="loading"
    >
      <v-list-item-icon>
        <v-icon v-if="!loading" color="primary">mdi-account-group</v-icon>
        <v-progress-circular
          v-else
          indeterminate
          size="24"
          width="2"
        ></v-progress-circular>
      </v-list-item-icon>
      <v-list-item-title>
        {{ loading ? 'Processing...' : 'Upgrade to Pro Team' }}
      </v-list-item-title>
    </v-list-item>

    <!-- Team Management -->
    <v-list-item
      v-if="user.is_pro_team && isActiveSubscription"
      @click="$emit('navigate-to-members')"
    >
      <v-list-item-icon>
        <v-icon color="primary">mdi-account-group</v-icon>
      </v-list-item-icon>
      <v-list-item-title>Manage Team Members</v-list-item-title>
    </v-list-item>

    <v-divider v-if="user.is_pro_team && isActiveSubscription"></v-divider>

    <!-- Cancel Subscription -->
    <v-list-item
      v-if="isActiveSubscription && (user.is_pro || user.is_pro_team)"
      @click="$emit('cancel')"
      :disabled="loading"
    >
      <v-list-item-icon>
        <v-icon color="warning">mdi-steering-off</v-icon>
      </v-list-item-icon>
      <v-list-item-title>Cancel Subscription</v-list-item-title>
    </v-list-item>

    <!-- Reactivate Subscription -->
    <v-list-item
      v-if="user.subscription_status === 'canceled' && currentUser.loggedIn"
      @click="$emit('reactivate')"
      :disabled="loading"
    >
      <v-list-item-icon>
        <v-icon v-if="!loading" color="primary">mdi-restore</v-icon>
        <v-progress-circular
          v-else
          indeterminate
          size="24"
          width="2"
        ></v-progress-circular>
      </v-list-item-icon>
      <v-list-item-title>
        {{ loading ? 'Processing...' : 'Reactivate Subscription' }}
      </v-list-item-title>
    </v-list-item>

    <!-- Login Options -->
    <v-list-item v-if="!currentUser.loggedIn">
      <v-list-item-icon>
        <v-icon>mdi-fingerprint</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title class="success--text">
          Login To Try Pro
        </v-list-item-title>
        <v-list-item-subtitle>
          <v-btn
            color="primary"
            text
            @click="$emit('login', 'google')"
            class="px-2 mt-2"
          >
            <v-icon left>mdi-google</v-icon>
            Google
          </v-btn>
          <v-btn
            text
            color="primary"
            class="mt-2 ml-5"
            @click="$emit('login', 'email')"
          >
            <v-icon left>mdi-email-outline</v-icon>
            Email
          </v-btn>
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <!-- Logout -->
    <v-list-item v-if="currentUser.loggedIn" @click="$emit('logout')">
      <v-list-item-icon>
        <v-icon color="primary">mdi-logout</v-icon>
      </v-list-item-icon>
      <v-list-item-title>Logout</v-list-item-title>
    </v-list-item>
  </div>
</template>

<script>
export default {
  name: 'SubscriptionActions',

  props: {
    user: {
      type: Object,
      required: true,
    },
    currentUser: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    isActiveSubscription() {
      return this.user.is_active ||
             this.user.subscription_status === 'active' ||
             this.user.subscription_status === 'team_pro';
    }
  }
};
</script>

<style scoped>
.try-pro-text {
  font-weight: 500;
}

.login-highlight {
  color: #1976d2;
  font-weight: 500;
}
</style>
